import appTheme from '../../themes/Theme';
import styled from 'styled-components';
import { BreakPoints } from '../../constants/BreakPoints';
import { Color } from '../../constants/Color';

export const StyledWrapper = styled.div`
  background-color: ${appTheme.backgroundColor};
`;

export const StyledWrapperLeft = styled.div`
  padding: 8px;
  position: sticky;
  top: 60px;
  bottom: 0;
  border-right: 1px solid #dadde1;
  height: calc(100vh - 74px); 
  overflow-y: scroll;
  background-color: ${appTheme.backgroundColor};

  @media (max-width: ${BreakPoints.tablet}) {
    display: none;
  }
`;

export const StyledWrapperRight = styled.div`
  padding-left: 16px;
  margin-right: 16px;
  min-height: calc(100vh - 202px);
`;

export const StyledButtonSidebar = styled.div`
  position: fixed;
  padding: 4px 12px;
  bottom: 16px;
  right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Color.AthensGray};
  border-radius: 4px;
  display: none;
  color: black;

  @media (max-width: ${BreakPoints.tablet}) {
    display: block;
  }
`;
